import Vue from 'vue'

import {
  COLOR_CLASS,
  BG_COLOR_CLASS,
  THEME_BG_CLASS,
  THEME_LIGHT_BG_COLOR,
  BORDER_COLOR_CLASS
} from '@/defines/environment/config'

// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  computed: {
    themeColorClass() {
      return [COLOR_CLASS]
    },
    themeLightBgColor() {
      return [THEME_LIGHT_BG_COLOR]
    },
    themeAppColorClass() {
      return THEME_BG_CLASS
    },
    themeBgColorClass() {
      return [BG_COLOR_CLASS]
    },
    borderColorClass() {
      return [BORDER_COLOR_CLASS]
    }
  }
})
